module.exports = __webpack_public_path__ + "media/images/splash-screen/logo-fe0a4d44095cfd630e0f56666f2c4601.svg";